import { observer } from "mobx-react";
import "./index.css";
import CallStore from "../../stores/CallStore";
import CallSessionInformation from "../CallSessionInformation";
import { questionIcon, whiteCheckIcon } from "../../assets";
import { useContext } from "react";
import { ModalAlertContext } from "../../contexts/ModalAlertContext";
import strings from "../../localization";
import CallSelectIssue from "../CallSelectIssue";
import { IssueSolvedList } from "../../helpers/statics";
import TechCallSessionNotes from "../TechCallSessionNotes";

const TechEndCallModal = ({ client }) => {


  const sparePart = CallStore.call?.sparePart ? CallStore.call.sparePart : '';
  const issue = CallStore.call?.result ? CallStore.call.result : 'resolved';

  const { showModalAlert, closeModalAlert, showRateOurServiceAlert } = useContext(ModalAlertContext);


  if (!CallStore.techEndCallModal) {
    return null;
  }

  const endCall = async () => {
    const selectedIssue = IssueSolvedList.find(item => item.key === issue) || IssueSolvedList[0];
    var body = {};

    if (selectedIssue.key === 'spare_part_needed') {
      body = {
        result: selectedIssue.key,
        note: CallStore.call?.note,
        sparePart: sparePart,
        reason: 'Technician End Call'
      }
    } else {
      body = {
        result: selectedIssue.key,
        note: CallStore.call?.note,
        reason: 'Technician End Call'
      }
    }


    const response = await CallStore.endCallByTech(CallStore.slug, body);
    return response;
  }

  const handleEndCall = () => {

    showModalAlert(
      {
        title: strings.endSession,
        message: strings.areYouSureYouWantToEndTheCall,
        confirmText: strings.yesDoIt,
        cancelText: strings.endAndGoToRating,
        type: "error",
        position: "vertical",
        icon: questionIcon,
        onConfirm: async () => {
          const response = await endCall();

          if (response.success) {
            localStorage.removeItem('callToken');
            client?.leave();
            closeModalAlert();

            showModalAlert({
              title: strings.callFinished,
              message: strings.yourSessionCallHasBeenFinished,
              type: "error",
              confirmText: strings.goToSessionLog,
              onConfirm: () => {
                closeModalAlert();
                window.location = `/tech/session/${response.data.slug}`;
                CallStore.setTechEndCallModal(false);
              },
              onCancel: null
            });
          } else {
            showModalAlert({
              title: strings.error,
              message: response.message,
              type: "error",
              confirmText: strings.ok,
              onConfirm: () => {
                closeModalAlert();
              },
              onCancel: null
            });
          }

        },
        onCancel: async () => {

          const response = await endCall();

          if (response.success) {
            localStorage.removeItem('callToken');
            closeModalAlert();

            showModalAlert({
              title: strings.callFinished,
              message: strings.yourSessionCallHasBeenFinished,
              type: "error",
              confirmText: strings.pleaseRateOurService,
              onConfirm: () => {
                closeModalAlert();
                showRateOurServiceAlert();
              },
              onCancel: null
            });
          } else {
            showModalAlert({
              title: strings.error,
              message: response.message,
              type: "error",
              confirmText: strings.ok,
              onConfirm: () => {
                closeModalAlert();
              },
              onCancel: null
            });
          }

        },
        footer: (
          <div className="modal-alert-custom-footer">
            <button className="button-text-cta button-text-cta-medium"
              onClick={() => {
                closeModalAlert();
              }}
            >
              <span>{strings.cancel}</span>
            </button>
          </div>
        )
      });
  }

  const handleBackdropClick = () => {
    CallStore.setTechEndCallModal(false);
  }

  const handleContentClick = (e) => {
    e.stopPropagation();
  }


  var complateDisabled = false;
  if (issue === 'spare_part_needed') {
    complateDisabled = sparePart === '';
  } else {
    complateDisabled = !issue;
  }


  return (
    <div className="tech-end-call-modal" onClick={handleBackdropClick}>
      <div className="tech-end-call-modal-content" onClick={handleContentClick}>
        <div className="tech-end-call-modal-content-header">
          <span className="tech-end-call-modal-content-header-title">{strings.sessionSummary}</span>
          <p className="tech-end-call-modal-content-header-description">{strings.completeTheSessionReportBeforeEndingTheCall}</p>
        </div>
        <CallSessionInformation />
        <CallSelectIssue />
        {/* <div className="tech-end-call-modal-content-session-notes">
          <TextArea label={strings.sessionNotesAndComments} placeholder={strings.enterYourNotesHere} value={CallStore.call?.note} onChange={CallStore.setSessionNotes} />
        </div> */}
        <TechCallSessionNotes showImages={false} textAreaStyle={{ height: '100px' }} />
        <div className="tech-end-call-modal-content-footer">
          <button className="button-cta-secondary" disabled={complateDisabled} onClick={handleEndCall}>
            <img src={whiteCheckIcon} alt="end call" />
            <span>{strings.completeSession}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default observer(TechEndCallModal);